module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-2d90317a.png";